export default "__VITE_ASSET__SussngbT__"